import { render } from "./CompleteIDVerificationPreviewModal.vue?vue&type=template&id=0bdcd7ad&ts=true"
import script from "./CompleteIDVerificationPreviewModal.vue?vue&type=script&lang=ts"
export * from "./CompleteIDVerificationPreviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__